// All 13 projects — every project has a complete gallery from its respective folder
export const PORTFOLIO_PROJECTS = [
  {
    id: 1,
    name: 'SAWARIYA GROUP',
    location: 'Ankleshwar, GIDC',
    area: '52,000 Sq. Ft.',
    category: 'Manufacturing',
    featured: true,
    badge: 'Largest Project',
    description: 'A large-scale manufacturing facility at GIDC Ankleshwar — Gujarat\'s premier industrial zone. The project required a multi-span PEB design to accommodate heavy industrial operations across a 52,000 Sq. Ft. footprint with precision execution.',
    scopeOfWork: [
      'Multi-span PEB structural design and full erection',
      'Reinforced concrete foundations with deep footings',
      'Metal roofing and perimeter wall cladding',
      'Industrial flooring with load-rated concrete slab',
      'Utility provisions: electrical, drainage, ventilation',
      'Compound walling and internal road layout',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.19 PM_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.19 PM_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.13 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.13 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.14 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.14 PM (2)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.14 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.15 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.15 PM (2)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.15 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.16 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.16 PM (2)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.16 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.17 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.17 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.18 PM (3)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.18 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.19 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.19 PM (2)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.19 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SAWARIYA GROUP/WhatsApp Image 2021-09-14 at 5.36.20 PM_result.webp',
    ],
  },
  {
    id: 2,
    name: 'ARYA INDUSTRIES',
    location: 'Supa MIDC',
    area: '40,000 Sq. Ft.',
    category: 'Warehouses',
    featured: true,
    badge: 'Warehouse Complex',
    description: 'A high-capacity warehouse and industrial facility at Supa MIDC. The 40,000 Sq. Ft. structure incorporates optimised column spacing for unrestricted internal movement, dock levelling provisions, and full utility infrastructure.',
    scopeOfWork: [
      'Single-span clear-span PEB structure',
      'Heavy-duty industrial flooring with epoxy coating',
      'Full dock levelling provisions for logistics',
      'Internal partition walls and mezzanine office',
      'Fire safety systems — hydrant and sprinkler ready',
      'Electrical and industrial lighting provisions',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/ARYA INDUSTRIES/WhatsApp Image 2021-09-08 at 2.01.04 PM_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/ARYA INDUSTRIES/WhatsApp Image 2021-09-08 at 2.01.04 PM_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/ARYA INDUSTRIES/WhatsApp Image 2021-09-08 at 2.01.05 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/ARYA INDUSTRIES/WhatsApp Image 2021-09-08 at 2.01.05 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/ARYA INDUSTRIES/WhatsApp Image 2021-09-08 at 2.01.06 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/ARYA INDUSTRIES/WhatsApp Image 2021-09-08 at 2.01.06 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/ARYA INDUSTRIES/WhatsApp Image 2021-09-08 at 2.01.07 PM_result.webp',
    ],
  },
  {
    id: 3,
    name: 'VRS FOODS LTD.',
    location: 'Maharashtra',
    area: '15,000 Sq. Ft.',
    category: 'Food Processing',
    featured: true,
    badge: 'Food Grade',
    description: 'A hygienic food-grade processing facility built to food safety construction standards. This project demanded food-safe construction materials, smooth finishes, and integrated drainage — executed by Kadam Patil Projects from design to handover.',
    scopeOfWork: [
      'PEB structural frame with insulated cladding panels',
      'Food-grade anti-bacterial epoxy floor coating',
      'Dado tile work to wall surfaces for hygiene compliance',
      'Stainless steel drainage channels and sump units',
      'Air handling unit provisions and false ceiling work',
      'Cold room preparation and utility infrastructure',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/VRS FOODS LTD/IMG_0834_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/VRS FOODS LTD/IMG_0834_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/VRS FOODS LTD/IMG_0794_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/VRS FOODS LTD/IMG_0795_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/VRS FOODS LTD/IMG_0833_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/VRS FOODS LTD/IMG_0834_result.webp',
    ],
  },
  {
    id: 4,
    name: 'SP ENTERPRISES',
    location: 'Newasa MIDC',
    area: '12,000 Sq. Ft.',
    category: 'PEB',
    featured: false,
    badge: 'PEB Structure',
    description: 'A well-planned PEB industrial shed at Newasa MIDC delivering high structural efficiency across a 12,000 Sq. Ft. footprint, suited for light to medium manufacturing operations.',
    scopeOfWork: [
      'Portal frame PEB structure with intermediate columns',
      'Corrugated sheet roofing and perimeter wall cladding',
      'Concrete plinth beam and structural flooring',
      'Electrical provisions — LT panel to distribution boards',
      'Ventilation louvers and natural lighting provisions',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0331_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0331_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0075_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0078_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0159_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0160_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0161_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0162_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0163_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0266_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0270_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0271_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0272_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0282_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0283_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0331_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0332_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0338_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_0341_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_1718_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_20230926_130734221_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_20230929_024629_682_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SP ENTERPRISES/IMG_20230929_024629_721_result.webp',
    ],
  },
  {
    id: 5,
    name: 'RAVIKIRAN ENTERPRISES',
    location: 'Newasa MIDC',
    area: '8,092 Sq. Ft.',
    category: 'Industrial Sheds',
    featured: false,
    badge: 'Completed Project',
    description: 'An industrial shed facility at Newasa MIDC with precision structural work across an 8,092 Sq. Ft. area — built for medium-scale manufacturing and assembly operations.',
    scopeOfWork: [
      'Twin chord clear-span PEB frame structure',
      'Metal roofing with gutters and downpipe network',
      'Plinth beam, RCC flooring, and boundary wall',
      'Security cabin and motorised entry gate',
      'Exterior finishing with textured external plaster',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2171_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2171_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240626-WA0023_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240701-WA0015_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240703-WA0009_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240703-WA0010_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240705-WA0007_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240707-WA0031_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240707-WA0032_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240707-WA0033_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240707-WA0034_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240707-WA0035_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240708-WA0019_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240708-WA0020_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240708-WA0021_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240708-WA0022_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240712-WA0018_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240712-WA0019_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240712-WA0020_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240712-WA0021_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240712-WA0022_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20240716-WA0002_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241002-WA0002_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241002-WA0003_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241002-WA0004_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241009-WA0007_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241009-WA0009_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241009-WA0010_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241009-WA0011_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241010-WA0011_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241010-WA0013_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241014-WA0015_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241014-WA0016_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241015-WA0017_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241015-WA0018_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG-20241015-WA0019_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_1756_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240516_130355328_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240516_130406531_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240624_113401962_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240624_122330091_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240624_124435700_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240701_125516096_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240701_125554105_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240701_125555995_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240703_230815_987_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240703_230816_278_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240704_170502_574_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240704_170502_651_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240704_170502_875_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_20240704_170840743_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2171_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2172_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2173_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2174_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2175_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2176_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2177_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/RAVIKIRAN_ENTERPRISES/IMG_2178_result.webp',
    ],
  },
  {
    id: 6,
    name: 'AKSHARA ENTERPRISES',
    location: 'Newasa MIDC',
    area: '6,000 Sq. Ft.',
    category: 'PEB',
    featured: false,
    badge: 'PEB Structure',
    description: 'A precision-built PEB structure at Newasa MIDC. The 6,000 Sq. Ft. facility is optimised for lean manufacturing workflows with a column-free interior zone and high-clearance eave height.',
    scopeOfWork: [
      'Single-slope PEB frame with extended canopy',
      'Galvalume roofing sheets — anti-corrosion grade',
      'Hard-core flooring with 5-inch structural RCC slab',
      'Shuttering and casting of all structural columns',
      'Plumbing provisions and drainage slope channel',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20240129_151417650_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20240129_151417650_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_0909_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1106_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1107_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1108_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1109_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1110_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1111_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1112_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1113_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1138_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1140_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1142_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1143_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1144_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1145.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1146.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_1147.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20231006_180155913_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20231125_160229889_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20231223_115138728_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20231228_144112602_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20240128_152500078_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20240129_121527628_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20240129_151135906_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20240129_151321362_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/AKSHARA_ENTERPRISES/IMG_20240129_151417650_result.webp',
    ],
  },
  {
    id: 7,
    name: 'OGEN INDUSTRIES',
    location: 'Newasa MIDC',
    area: '6,000 Sq. Ft.',
    category: 'Manufacturing',
    featured: false,
    badge: 'Completed Project',
    description: 'A dedicated manufacturing shed at Newasa MIDC built for light engineering use. Emphasised fast delivery timelines and cost efficiency without compromising structural quality.',
    scopeOfWork: [
      'Gabled portal PEB frame — single bay configuration',
      'Pre-finished colour-coated roofing panels',
      'RCC plinth and industrial-grade floor finish',
      'Overhead crane rail provision for material handling',
      'Internal and perimeter drainage network',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20230608-WA0004 - Copy_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20230608-WA0004 - Copy_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240523-WA0007_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240523-WA0008_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240523-WA0009_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240523-WA0010_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240523-WA0011_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240524-WA0007_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240524-WA0008_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240524-WA0009_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240524-WA0010_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240528-WA0021_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240528-WA0022_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240528-WA0023_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240528-WA0024_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240528-WA0025_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG-20240528-WA0026_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG_1278_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG_20240113_135710707_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/OGEN_INDUSTRIES/IMG_20240213_105802905_result.webp',
    ],
  },
  {
    id: 8,
    name: 'DHRUV ENTERPRISES',
    location: 'Newasa MIDC',
    area: '6,000 Sq. Ft.',
    category: 'Industrial Sheds',
    featured: false,
    badge: 'Completed Project',
    description: 'An industrial shed at Newasa MIDC delivering a clean, functional space for precision assembly and storage — completed on schedule within a 6,000 Sq. Ft. structural envelope.',
    scopeOfWork: [
      'Bi-pitch portal frame with eave strut connections',
      'Insulated sandwich panel roofing system',
      'High-quality plinth and apron finish surfaces',
      'Mezzanine office space within structural envelope',
      'Electrical main feeder and earthing grid',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/DHRUV_ENTERPRISES/IMG-20230608-WA0004 - Copy - Copy_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/DHRUV_ENTERPRISES/IMG-20230608-WA0004 - Copy - Copy_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/DHRUV_ENTERPRISES/IMG-20231226-WA0014_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/DHRUV_ENTERPRISES/IMG-20231229-WA0009_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/DHRUV_ENTERPRISES/IMG_20231107_141113732_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/DHRUV_ENTERPRISES/IMG_20231107_141122086_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/DHRUV_ENTERPRISES/IMG_20240129_151610364_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/DHRUV_ENTERPRISES/IMG_20240129_151933906_result.webp',
    ],
  },
  {
    id: 9,
    name: 'POWER SOLUTIONS',
    location: 'Newasa MIDC',
    area: '4,500 Sq. Ft.',
    category: 'PEB',
    featured: false,
    badge: 'PEB Structure',
    description: 'A specialised PEB industrial shed for an electrical equipment manufacturer — built to accommodate heavy equipment storage and assembly within a 4,500 Sq. Ft. structural envelope.',
    scopeOfWork: [
      'Mono-pitch PEB frame — SSCS (Single Slope Clear Span)',
      'Heavy-duty anchoring provisions for equipment loads',
      'Industrial epoxy floor coating — high-load rated',
      'Cable tray provisions and earthing grid throughout',
      'Water supply, drainage and security provisions',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/POWER_SOLUTIONS/IMG-20220901-WA0002_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/POWER_SOLUTIONS/IMG-20220901-WA0002_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/POWER_SOLUTIONS/IMG_0350_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/POWER_SOLUTIONS/IMG_0351_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/POWER_SOLUTIONS/IMG_0402_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/POWER_SOLUTIONS/IMG_0403_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/POWER_SOLUTIONS/IMG_0404_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/POWER_SOLUTIONS/IMG_0411_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/POWER_SOLUTIONS/IMG_20230506_142956747_result.webp',
    ],
  },
  {
    id: 10,
    name: 'BHOOMATA FOOD PRODUCT',
    location: 'Pandharipul MIDC',
    area: '4,000 Sq. Ft.',
    category: 'Food Processing',
    featured: false,
    badge: 'Food Grade',
    description: 'A compact food processing unit at Pandharipul MIDC built to hygienic standards. The 4,000 Sq. Ft. facility features food-grade finishes, robust drainage, and a structurally sound PEB envelope.',
    scopeOfWork: [
      'PEB structural frame with perimeter cladding',
      'Anti-skid tile flooring with drainage slope channels',
      'Dado tile work to wall surfaces per food safety norms',
      'Stainless drainage channels and trap systems',
      'Ventilation and exhaust duct provisions',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/Bhoomata_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/Bhoomata_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2021-09-09 at 6.56.56 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2021-09-09 at 6.56.56 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2021-09-17 at 8.18.51 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2021-09-17 at 8.18.51 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2021-09-17 at 8.18.52 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2021-09-17 at 8.18.52 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.07 PM (1).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.07 PM (2).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.07 PM.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.08 PM (1).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.08 PM (2).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.08 PM.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.09 PM (1).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.09 PM (2).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.10 PM (1).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.10 PM (2).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.10 PM.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.11 PM (1).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.11 PM (2).webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.11 PM.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/BHOOMATA_FOOD/WhatsApp Image 2026-06-16 at 1.45.12 PM (1).webp',
    ],
  },
  {
    id: 11,
    name: 'PARAKH AGRO FOOD PVT. LTD.',
    location: 'Yavat, Daund',
    area: '4,000 Sq. Ft.',
    category: 'Food Processing',
    featured: false,
    badge: 'Agro Processing',
    description: 'An agro-food processing facility at Yavat, Daund — designed for food-grade construction with robust agricultural processing infrastructure integrated into a 4,000 Sq. Ft. PEB structure.',
    scopeOfWork: [
      'PEB frame with thermal insulation cladding system',
      'Reinforced loading dock and weighbridge provisions',
      'Hygienic wall and floor finishes per food standards',
      'Industrial drainage with wastewater treatment provision',
      'Utility services — water, power, gas and fire safety lines',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/PARAKH AGRO/WhatsApp Image 2021-09-14 at 5.41.08 PM_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/PARAKH AGRO/WhatsApp Image 2021-09-14 at 5.41.08 PM_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/PARAKH AGRO/WhatsApp Image 2021-09-14 at 5.41.09 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/PARAKH AGRO/WhatsApp Image 2021-09-14 at 5.41.10 PM (1)_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/PARAKH AGRO/WhatsApp Image 2021-09-14 at 5.41.10 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/PARAKH AGRO/WhatsApp Image 2021-09-14 at 5.41.11 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/PARAKH AGRO/WhatsApp Image 2021-09-14 at 5.41.12 PM_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/PARAKH AGRO/WhatsApp Image 2021-09-14 at 5.41.14 PM_result.webp',
    ],
  },
  {
    id: 12,
    name: 'SHUBHARAM TILES',
    location: 'Ahmednagar District',
    area: '9,000 Sq. Ft.',
    category: 'Manufacturing',
    featured: false,
    badge: 'Completed Project',
    description: 'A tile manufacturing and display facility — combining an industrial production shed with a front-facing showroom. Executed to high finish standards, balancing functional production space with a premium customer-facing front.',
    scopeOfWork: [
      'Dual-use PEB frame — production area and showroom',
      'High-load rated flooring for tile storage and display',
      'Acoustic and thermal wall treatment panels',
      'Display area with polished concrete and glass frontage',
      'Full electrical, CCTV and security infrastructure',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_1254_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_1254_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_1255_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_1256_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_1265_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_1266_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_1267_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_1268_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_20231225_143100353_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_20240103_161526325_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_20240103_161613562_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_20240103_161616576_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_20240103_161745343_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_20240103_181221130_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_20240104_170507683_result.webp',
      '/PROJECT_PHOTOS_OPTIMIZED/SHUBHARAMBH_TILES/IMG_20240113_101505102_result.webp',
    ],
  },
  {
    id: 13,
    name: 'UTKARSH ENTERPRISES',
    location: 'Newasa MIDC',
    area: '2,035 Sq. Ft.',
    category: 'Industrial Sheds',
    featured: false,
    badge: 'Compact Shed',
    description: 'A compact industrial shed at Newasa MIDC — efficiently utilising a 2,035 Sq. Ft. footprint with a structurally robust PEB design, suitable for small-scale fabrication and storage.',
    scopeOfWork: [
      'Lean-to / mono-pitch PEB structural frame',
      'Corrugated roofing with overhangs and drainage gutters',
      'Mass concrete flooring with hard trowel finish',
      'Manual rolling shutters — 2 nos. with chain mechanism',
      'Basic utility provisions — electrical and water supply',
    ],
    heroImg: '/PROJECT_PHOTOS_OPTIMIZED/UTKARSH_ENTERPRISES/IMG_1866_result.webp',
    thumbImg: '/PROJECT_PHOTOS_OPTIMIZED/UTKARSH_ENTERPRISES/IMG_1866_result.webp',
    gallery: [
      '/PROJECT_PHOTOS_OPTIMIZED/UTKARSH_ENTERPRISES/IMG_1867_result.webp',
    ],
  },
];
